<template>
  <div>
    <!-- <InterForm @querySubmit="queryHandler" @overEmit="getDataSource" :prentType="prentType" :shopList="shopList" /> -->
    <!--    FBA -&ndash;&gt; 打包中 btns： 有 '导出发货单'、'批量修改物流公司'-->
    <!--    大包 -&ndash;&gt; 打包中 btns： 有 '导出发货单'、'批量修改物流公司'-->
    <!--    小包 -&ndash;&gt; 打包中 btns： 有 '导出发货单'、'批量修改物流公司'、'批量获取运单号'-->
    <InterBtnBox :selectedRows="selectedRows" modify-btn @overEmit="getDataSource" :singleProduct="query.singleProduct"
      :prentType="prentType" @refeash="getDataSource" />
    <InterList tableType="buildingBag" @refeash="getDataSource" layout="logistics" :dataSource="dataSource"
      :clean='clean' :singleProduct="query.singleProduct" @pageChange="pageChangeCall" @selectChange="selectChangeCall"
      :prentType="prentType" ref="interlist" :forwarder="$attrs.forwarder" :total="query.total"></InterList>
  </div>
</template>

<script>
import InterForm from "@/views/outOfStock/internationalShipment/components/InterForm";
import InterList from "@/views/outOfStock/internationalShipment/components/InterList";
import InterBtnBox from "@/views/outOfStock/internationalShipment/components/InterBtnBox";
import { shipTask } from "@/apis/outStock";
import { deliveryStatus, deliveryTypes } from "@/views/outOfStock/internationalShipment/tabs/index";

export default {
  title: "打包中",
  name: "buildingBag", // 打包中
  components: {
    InterForm,
    InterList,
    InterBtnBox,
  },
  props: {
    prentType: String,
    shopList: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      query: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      clean: false,
      selectedRows: [],
      dataSource: [],
    };
  },
  mounted() {
    this.getDataSource();
  },
  methods: {
    queryHandler: function (payload) {
      console.log(payload)
      this.query = {
        ...this.query,
        ...payload,
      };
      this.query.current = 1
      this.getDataSource()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    selectChangeCall: function (rows) {
      this.selectedRows = rows;
    },
    getDataSource: function () {
      // console.log(this.query)
      // 获取列表数据
      this.selectedRows = [];
      const params = {
        ...this.query,
        pageNum: this.query.current,
        deliveryStatus: deliveryStatus["buildingBag"],
        deliveryType: deliveryTypes[this.prentType],
      };
      this.clean = true;
      shipTask(params)
        .then((res) => {
          const {
            data: { total = 0, records = [] },
          } = res;
          records.forEach(item => {
            let text = ''
            if (item.channelNo && item.logisticsChannelDTOList) {
              item.logisticsChannelDTOList.forEach(item_son => {
                if (item_son.channelNo == item.channelNo) {
                  text = item_son.channelName
                }
              })
            }
            item.channelNo = text
          })
          this.query.total = total;
          this.dataSource = records;
          // const {}
        })
        .finally((_) => {
          this.clean = false;
        });
    },
  },
};
</script>

<style scoped>
</style>
